import { defineMessages } from 'react-intl';

var messages = defineMessages({
  loadingAriaLabel: {
    id: "neptune.Button.loadingAriaLabel"
  }
});

export { messages as default };
//# sourceMappingURL=Button.messages.mjs.map
